<template>
<div>
  <div class="sa-mob-header">
    <h5 class="sa-card-tit">Prescription details</h5>
    <button class="sa-btn-back" @click="backAction">
        <i class="icon-arrow-left"></i>
      </button>
  </div>
  <div class="sa-mob-cont">
    <div class="sa-row">
      <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
        <h6 class="sa-card-tit">General Information</h6>
        <div class="sa-card sa-card-border sa-card-noshadow">
          <dl>
            <dt><span class="sa-dark-gray-text">Status : </span><span class=" sa-green-text">{{generic.presc_status || 'Pending'}}</span></dt>
            <dt><span class="sa-dark-gray-text">Patient name : </span>{{generic.name}}</dt>
            <dt><span class="sa-dark-gray-text">Patient Identity : </span>{{generic.pid}}</dt>
            <dt><span class="sa-dark-gray-text">Issue Date : </span>{{generic.presc_date}}</dt>
          </dl>
        </div>
      </div>
      <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg8">
        <h6 class="sa-card-tit">Current Diagnosis</h6>
        <textarea v-model="presc_desc" class="sa-form-control sa-form-control-lg sa-form-c-lg" rows="10" id="currentdiagnosis" name="Current Diagnosis" placeholder=""></textarea>
      </div>   -->
    </div>
  </div>
</div>
</template>
<script>
export default {
  props:['generic'],
  components: {},
  data() {
    return {
      presc_desc: null
    };
  },
  methods: {
    backAction: function() {
      let _self = this;
      if(!_self.$parent.saveDrugFlag){
        _self.$parent.saveDrugFlag = true
        _self.$parent.saveDrugViewFlag = true
      }else {
        _self.$parent.saveDrugFlag = false
        _self.$parent.saveDrugViewFlag = false
      }
      // this.$router.push('/appointments/doctor-details/add-diagnosis/add-prescription/'+this.$route.params.appid)
      // window.location = '/appointments/doctor-details/add-diagnosis/add-prescription/'+this.$route.params.appid
    }
  },
  mounted() {
    this.presc_desc = this.generic.diagnosis
  },
};
</script>